import { render, staticRenderFns } from "./ItemRelease.vue?vue&type=template&id=5513cc97&"
import script from "./ItemRelease.vue?vue&type=script&lang=js&"
export * from "./ItemRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports